import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route } from 'react-router-dom';
import { init } from '@visma/formula/lib/dll';
import DLL from '@visma/formula/lib/dll';
import AppContainerBase from './base/AppContainerBase';

async function main() {
  const baseUrl = window.omataysPublicFormsPortlet.frontendProperties.formulaUrl;
  await init(baseUrl);

  ReactDOM.render(
    <DLL.FormulaProvider
      axios={(axios) => {
        axios.defaults.baseURL = baseUrl + '/api';
      }}
    >
      <HashRouter>
        <Route path="/form/:credentials">
          <AppContainerBase formulaUrl={baseUrl} />
        </Route>
      </HashRouter>
    </DLL.FormulaProvider>,
    document.getElementById('omatays-public-forms-portlet-main')
  );
}

main();
